import React from 'react'

const Lenguaje = ()=>{
    return(<h1>Lenguaje</h1>)
}

export default Lenguaje